export default __webpack_public_path__ + "static/media/sand-clock.e042d79f.svg";